import { FC } from "react";
import cls from "./index.module.css";
import {
  Container,
  ContainerTile,
  H1,
  SubText,
} from "components/styled-components/generic";
import BatterySlider, { BatterySliderProps } from "../battery-slider";
import { Car } from "shared-types";

export interface BatteryDetailsProps extends BatterySliderProps {
  carModel: Car;
}

export const BatteryDetails: FC<BatteryDetailsProps> = ({
  setBatteryLevel,
  batteryLevel,
}) => {
  return (
    <>
      <ContainerTile>
        <H1>Batteriezustand</H1>
        <SubText textAlign="center">
          Meine aktuelle Batteriekapazität beträgt:{" "}
          <span className={cls["highlight"]}>{batteryLevel[0]} %</span>
        </SubText>
        <SubText textAlign="center">
          Ich möchte meine Batterie aufladen auf:{" "}
          <span className={cls["highlight-desired-level"]}>
            {batteryLevel[1]} %
          </span>
        </SubText>
      </ContainerTile>
      <BatterySlider
        setBatteryLevel={(e) => setBatteryLevel(e)}
        batteryLevel={batteryLevel}
      />
    </>
  );
};
